import { Component } from '@angular/core';

@Component({
  selector: 'flash-card',
  templateUrl: 'flash-card.html'
})
export class FlashCardComponent {

  flipped: boolean = false;

  constructor() {

  }

  flip(){
    this.flipped = !this.flipped;
    console.log('flipping');
  }

}


// WEBPACK FOOTER //
// ./src/components/flash-card/flash-card.ts